/*
 * Módulo redux de Marcaciones (attendance_module) y llamadas del tablero.
 * Redux guarda el listado crudo (_get_attendance_list, /attendance/list/) y el horario de marcación
 * (_get_attendance_schedule / _update_attendance_schedule, usados por "Configurar horarios").
 * Las llamadas del tablero (fetchWorkdays, fetchHours, fetchDashboard) NO pasan por el store: devuelven la promesa
 * con `{cantidad, datos}` y la pantalla guarda el resultado en su estado (hooks/useRemoteData.js),
 * porque el store completo se persiste en localStorage (redux-persist) y las jornadas pesan.
 * downloadAttendanceExcel devuelve el Blob del .xlsx de GET /attendance/exportar/.
 */
import {URLAPI, ATTENDANCE_LIST_PATH, ATTENDANCE_SCHEDULE_PATH, ATTENDANCE_WORKDAYS_PATH, ATTENDANCE_HOURS_PATH, ATTENDANCE_DASHBOARD_PATH,
    ATTENDANCE_EXPORT_PATH} from "../config/index";
import axios from "axios";
import {LOGOUT} from './users'

const initialState = {
    _get_attendance_list: {
        data: [],
        status: 0,
        message: {},
    },
    _get_attendance_schedule: {
        data: [],
        status: 0,
        message: {},
    },
    _update_attendance_schedule: {
        data: {},
        status: 0,
        message: {},
    },
};

export const GET_ATTENDANCE_LIST = "_get_attendance_list";
export const GET_ATTENDANCE_SCHEDULE = "_get_attendance_schedule";
export const UPDATE_ATTENDANCE_SCHEDULE = "_update_attendance_schedule";

export const attendance_module = (state = initialState, action) => {
    switch (action.type) {
        case GET_ATTENDANCE_LIST:
            return {
                ...state,
                _get_attendance_list: action.payload,
            };
        case GET_ATTENDANCE_SCHEDULE:
            return {
                ...state,
                _get_attendance_schedule: action.payload,
            };
        case UPDATE_ATTENDANCE_SCHEDULE:
            return {
                ...state,
                _update_attendance_schedule: action.payload,
            };
        case LOGOUT:
            return initialState;
        default:
            return state;
    }
};

export const getAttendanceList = (token, paramsUrl) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${ATTENDANCE_LIST_PATH}${paramsUrl}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ATTENDANCE_LIST,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ATTENDANCE_LIST,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ATTENDANCE_LIST,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const getAttendanceSchedule = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${ATTENDANCE_SCHEDULE_PATH}`, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: GET_ATTENDANCE_SCHEDULE,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ATTENDANCE_SCHEDULE,
                payload: {
                    data: [],
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: GET_ATTENDANCE_SCHEDULE,
                payload: {
                    data: [],
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateAttendanceSchedule = (token, dia, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${ATTENDANCE_SCHEDULE_PATH}${dia}/`, data, {
            headers: {
                Authorization: `Token ${token}`,
            },
        });
        dispatch({
            type: UPDATE_ATTENDANCE_SCHEDULE,
            payload: {
                data: response.data,
                status: response.status,
                message: "Horario actualizado correctamente",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: UPDATE_ATTENDANCE_SCHEDULE,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_ATTENDANCE_SCHEDULE,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

const authHeaders = (token) => ({Authorization: `Token ${token}`});

/** GET /attendance/jornadas/ (una fila por empleado y día). params: fecha_desde, fecha_hasta, id_zona, id_tienda, id_empleado. */
export const fetchWorkdays = (token, params) =>
    axios.get(`${URLAPI}${ATTENDANCE_WORKDAYS_PATH}`, {params, headers: authHeaders(token)}).then((response) => response.data);

/** GET /attendance/horas/ (horas por persona y periodo). params: los de fetchWorkdays + agrupar (dia|semana|mes). */
export const fetchHours = (token, params) =>
    axios.get(`${URLAPI}${ATTENDANCE_HOURS_PATH}`, {params, headers: authHeaders(token)}).then((response) => response.data);

/** GET /attendance/dashboard/ (KPI, rankings, mapa de calor, tiendas, zonas, horas y alertas). params: los de fetchWorkdays. */
export const fetchDashboard = (token, params) =>
    axios.get(`${URLAPI}${ATTENDANCE_DASHBOARD_PATH}`, {params, headers: authHeaders(token)}).then((response) => response.data);

/** GET /attendance/exportar/ -> Blob del .xlsx. params: los de fetchWorkdays + seccion (+ agrupar en horas). */
export const downloadAttendanceExcel = (token, params) =>
    axios.get(`${URLAPI}${ATTENDANCE_EXPORT_PATH}`, {params, responseType: 'blob', headers: authHeaders(token)})
        .then((response) => response.data);
